const CalculateSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_9345_3974)">
        <path
          d="M2.75 1.5V4M4 2.75H1.5M4 8L3 9M3 9L2 10M3 9L4 10M3 9L2 8M10 3H8M10 9.25H8M10 7.75H8M11 6H1M6 11V1"
          stroke="#D5D5D5"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9345_3974">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalculateSvg;
